import React from 'react';


const PortfolioSelector = ({ selectedPortfolio, onPortfolioChange, portfolios }) => {
  return (
    <div className="relative">
      <select
        value={selectedPortfolio}
        onChange={(e) => onPortfolioChange(e?.target?.value)}
        className="h-9 md:h-10 pl-3 pr-10 rounded-lg bg-input border border-border text-foreground text-sm font-medium appearance-none cursor-pointer transition-smooth hover:border-primary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background w-full md:w-auto min-w-[180px]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23F5F5F7' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-referrer',
          backgroundPosition: 'right 0.75rem center',
          backgroundSize: '12px'
        }}
      >
        {portfolios?.map((portfolio) => (
          <option key={portfolio?.value} value={portfolio?.value}>
            {portfolio?.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PortfolioSelector;